import {
  OverlayArrow,
  Popover as AriaPopover,
  PopoverProps as AriaPopoverProps,
  composeRenderProps,
} from "react-aria-components";
import { cn } from "@/utils/helpers";
import { useCoShellPortal } from "../../CoShellPortalContext";
import { kitDropdownPanelClass } from "./dropdownStyles";

export interface KitPopoverProps extends Omit<AriaPopoverProps, "children"> {
  showArrow?: boolean;
  children: React.ReactNode;
}

export function KitPopover({ children, showArrow, className, ...props }: KitPopoverProps) {
  const portalContainer = useCoShellPortal();
  const offset = showArrow ? 12 : 6;
  return (
    <AriaPopover
      offset={offset}
      UNSTABLE_portalContainer={portalContainer ?? undefined}
      {...props}
      className={composeRenderProps(className, (cls, renderProps) =>
        cn(
          kitDropdownPanelClass,
          "z-[var(--z-index-popover)]",
          /* Menu open (library, Foundations / Motion): grows from the trigger
             on snappy, 97% to full and 4px toward its place; leaves in 120ms. */
          "origin-(--trigger-anchor-point)",
          renderProps.isEntering &&
            "animate-in fade-in zoom-in-97 placement-bottom:slide-in-from-top-1 placement-top:slide-in-from-bottom-1",
          renderProps.isExiting &&
            "animate-out fade-out zoom-out-97",
          cls,
        ),
      )}
    >
      {showArrow && (
        <OverlayArrow className="group">
          <svg
            width={12}
            height={12}
            viewBox="0 0 12 12"
            className="block fill-[var(--co-dropdown-panel-bg,#ffffff)] stroke-co-line stroke-1 group-placement-bottom:rotate-180 group-placement-left:-rotate-90 group-placement-right:rotate-90"
          >
            <path d="M0 0 L6 6 L12 0" />
          </svg>
        </OverlayArrow>
      )}
      {children}
    </AriaPopover>
  );
}
